import { combineReducers } from "redux";
import { reducer as funderDetails } from "./funderDetails";

export default combineReducers({
  funderDetails,
});
